/**
 * @generated SignedSource<<37ee5eaec597e35d55dbb7615ad2f6b1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueCreateFooter$data = {
  readonly __id: string;
  readonly " $fragmentType": "IssueCreateFooter";
};
export type IssueCreateFooter$key = {
  readonly " $data"?: IssueCreateFooter$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueCreateFooter">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "IssueCreateFooter",
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "bb4169454bfd5537e0b923f7af0c8e7e";

export default node;
